<template>
  <div>
    <div class="activity-content">
      <div class="right-content">
        <navigation :navName="nav"></navigation>
        <div class="search-info">
          <el-form :inline="true">
            <el-form-item label="文章标题">
              <el-input placeholder="请输入文章标题"
                        v-model="searchTitle"
                        size="mini"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         size="mini"
                         @click="search()">搜索</el-button>

            </el-form-item>
          </el-form>
        </div>
        <!--表格-->
        <div class="table-container">
          <el-button size="mini"
                     type="primary"
                     @click="goToEdit()">新增</el-button>
          <table-box :data="activityList"
                     ref="table"
                     :tableHeight="tableHeight"
                     id="rebateSetTable">
            <table-column prop="title"
                          label="标题"> </table-column>
            <table-column prop="editTime"
                          label="新建日期"
                          :width="'150px'"> </table-column>
            <table-column prop="updateTime"
                          label="更新时间"
                          :width="'200px'"> </table-column>
            <!-- <table-column prop="isSetHome"
                          label="推荐首页"
                          :width="'80px'"
                          :formatter="formatSetHome">

            </table-column> -->
            <table-column prop="editors"
                          label="编辑人"
                          :width="'120px'"> </table-column>
            <table-column prop="isSetTop"
                          label="是否置顶"
                          :width="'80px'"
                          :formatter="formatSetTop"> </table-column>
            <table-column prop="sort"
                          label="优先级排序"
                          :width="'100px'">
              <template slot-scope="scope">
                <el-input type="number"
                          min="0"
                          v-model="scope.row.sort"
                          size="mini"
                          @change="_sort(scope.row)">
                </el-input>
              </template>
            </table-column>
            <table-column label="操作"
                          :width="'160px'"
                          alignType="left">
              <template slot-scope="scope">
                <span class="table-btn"
                      @click="handleEdit(scope.$index, scope.row)">编辑</span>

                <span class="table-btn"
                      v-if="!scope.row.release"
                      @click="_publish(scope.row,true)">发布</span>
                <span class="table-btn"
                      v-if="scope.row.release"
                      @click="_publish(scope.row,false)">取消发布</span>
                <span class="table-btn delete"
                      v-if="!scope.row.have_page"
                      @click="deleteItem(scope.$index, scope.row)">删除</span>
              </template>
            </table-column>
          </table-box>
          <pagination @currentChange="handleCurrentChange"
                      @sizeChange="handleSizeChange"
                      :currentPage.sync="currentPage"
                      :pageSize.sync="pageSize"
                      :total="total">
          </pagination>
        </div>
        <!-- <div class="pager">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[5, 10, 20, 30]"
                         :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import navigation from './navigation';
import api from '../../api/api';

export default {
  data() {
    return {
      msg: {},
      navSelected: 'news',
      nav: '123',
      searchTitle: '',
      pageSize: 20,
      pageNum: 1,
      tableHeight: 0,
      currentPage: 1,
    };
  },
  components: {
    navigation,
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        document.documentElement.clientHeight - this.$refs.table.$el.offsetTop - 120;
    });
  },
  watch: {
    $route() {
      this.currentPage = 1;
      this.pageSize = 20;
    },
  },
  methods: {
    _sort(item) {
      axios.get(`${api.url}articleSort`, {
        params: {
          sort: item.sort,
          // eslint-disable-next-line no-underscore-dangle
          id: item._id,
        },
      }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          this.$message({
            type: 'success',
            message: data.msg,
          });
          const msg = {
            type: this.$store.state.navName,
            wid: this.$store.state.websiteId,
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            searchTitle: this.searchTitle,
          };
          this.$store.dispatch('getArticle', msg);
        }
      });
    },
    search() {
      const data = {
        type: this.$store.state.navName,
        wid: this.$store.state.websiteId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        searchTitle: this.searchTitle,
      };
      this.$store.dispatch('getArticle', data);
    },
    goToEdit() {
      localStorage.setItem('articleId', '');
      this.$store.commit('getArticleId', '');
      this.$router.push({
        path: 'addArticle',
      });
    },
    formatSetHome(row) {
      return row.isSetHome === true ? '是' : '否';
    },
    formatSetTop(row) {
      return row.isSetTop === 1 ? '是' : '否';
    },
    handleEdit(index, item) {
      localStorage.setItem('articleId', item._id);
      this.$store.commit('getArticleId', item._id);
      this.$router.push({
        path: 'addArticle',
      });
    },
    _publish(item, type) {
      axios.get(`${api.url}articleRelease`, {
        params: {
          id: item._id,
          type,
        },
      }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          this.$message({
            type: 'success',
            message: data.msg,
          });
          // eslint-disable-next-line no-param-reassign
          item.release = type;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      const data = {
        type: this.$store.state.navName,
        wid: this.$store.state.websiteId,
        pageSize: this.pageSize,
        pageNum: 1,
        searchTitle: this.searchTitle,

      };
      this.$store.dispatch('getArticle', data);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      const data = {
        type: this.$store.state.navName,
        wid: this.$store.state.websiteId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        searchTitle: this.searchTitle,
      };
      this.$store.dispatch('getArticle', data);
    },
    deleteItem(index, item) {
      const data = {
        id: item._id,
      };
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post(`${api.url}deleteArticle`, data).then((response) => {
          const articleData = response.data;
          if (articleData.ret === 0) {
            this.$store.state.activityList.splice(index, 1);
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          }
        });
      });
    },
  },
  computed: {
    ...mapState([
      'activityList',
      'total',
    ]),
  },
};
</script>
<style lang="less">
.el-table {
  max-height: ~"calc(100vh - 260px)";
  overflow: auto;
}
.navigation {
  margin-bottom: 16px;
}
// 搜寻模块
.search-info {
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 6px 6px -1px rgba(56, 132, 194, 0.1);
  padding: 0 16px;
  &.sfmobile {
    box-shadow: none;
  }
  .el-form-item__content {
    width: 200px;
  }
  .el-input--mini .el-input__inner {
    height: 28px;
    line-height: 28px;
    width: 200px;
  }
}
.table-container {
  margin-top: 8px;
}
.btn {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  .el-input {
    width: 40%;
    margin-right: 20px;
  }
}
.pager {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/websiteConfig/activity.vue